import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../../errors/responses';

const c = initContract();

export const ReservedStockLevel = z.object({
  daasCatalogItemId: z.string(),
  stockLevel: z.number()
});

export type ReservedStockLevel = z.infer<typeof ReservedStockLevel>;

export default c.router({
  getStockLevels: {
    method: 'GET',
    path: '/msp/:mspId/customers/:customerId/reservedStockLevels',
    responses: {
      200: z.object({
        items: z.array(ReservedStockLevel)
      }),
      ...failedResponses
    }
  },
  updateStockLevel: {
    method: 'PUT',
    path: '/msp/:mspId/customers/:customerId/reservedStockLevels',
    responses: {
      200: z.object({
        items: z.array(ReservedStockLevel)
      }),
      ...failedResponses
    },
    body: z.array(ReservedStockLevel)
  }
});
